import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';

const Contact: React.FC = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '', consent: false });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    emailjs.send('service_u1k3qho', 'template_dbi4cpj', {
      from_name: formData.name, from_email: formData.email, phone: formData.phone, message: formData.message,
    }, '3NAMOP-S1iyVt_TDE')
      .then(() => { setStatus('success'); setFormData({ name: '', email: '', phone: '', message: '', consent: false }); })
      .catch(() => setStatus('error'));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value }));
  };

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-8">{t('contact.title')}</h1>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-gray-50 rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-6 text-[#0A4A7A]">{t('contact.title')}</h2>
            <div className="space-y-4">
              <div><h3 className="font-semibold text-[#0A4A7A]">{t('contact.phone')}</h3><p className="text-gray-700">072-334 47 74</p></div>
              <div><h3 className="font-semibold text-[#0A4A7A]">{t('contact.email')}</h3><p className="text-gray-700">info@varmdohorsel.se</p></div>
              <div><h3 className="font-semibold text-[#0A4A7A]">{t('contact.address')}</h3><p className="text-gray-700">Gustavsbergs Värdshus,<br/>Algatan 3,<br />134 40 Gustavsberg</p></div>
              <div>
                <h3 className="font-semibold text-[#0A4A7A]">{t('contact.hours')}</h3>
                <p className="text-gray-700">{t('contact.monThu')}: 09:00 - 16:00<br />{t('contact.fri')}: 09:00 - 12:00<br/>{t('contact.sat')}: 10:00 - 14:00<br />{t('contact.sun')}: {t('contact.closed')}</p>
              </div>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-6 text-[#0A4A7A]">{t('contact.formTitle')}</h2>
            <form onSubmit={handleSubmit} className="space-y-4 bg-gray-50 rounded-lg p-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">{t('contact.name')} *</label>
                <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0A4A7A]" />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">{t('contact.emailLabel')} *</label>
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0A4A7A]" />
              </div>
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">{t('contact.phoneLabel')}</label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0A4A7A]" />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">{t('contact.message')} *</label>
                <textarea id="message" name="message" rows={4} required value={formData.message} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0A4A7A]" />
              </div>
              <div className="flex items-start">
                <input type="checkbox" id="consent" name="consent" required checked={formData.consent} onChange={handleChange} className="mt-1 mr-2" />
                <label htmlFor="consent" className="text-sm text-gray-600">{t('contact.consent')} <a href="/privacy" className="text-[#0A4A7A] hover:underline">{t('contact.privacyPolicy')}</a>. *</label>
              </div>
              <button type="submit" disabled={status === 'sending'} className="w-full bg-[#0A4A7A] text-white py-2 px-4 rounded hover:bg-[#083d66] transition-colors font-semibold disabled:opacity-50">
                {status === 'sending' ? t('contact.sending') : t('contact.send')}
              </button>
              {status === 'success' && <p className="text-green-600 text-center">{t('contact.success')}</p>}
              {status === 'error' && <p className="text-red-600 text-center">{t('contact.error')}</p>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
